import Index from "./Index.vue";
import SerialStart from "./SerialStart.vue";
import SerialConfirm from "./SerialConfirm.vue";
import SerialEnd from "./SerialEnd.vue";
import RegistrationStart from "./RegistrationStart.vue";
import RegistrationConfirm from "./RegistrationConfirm.vue";
import Order from "./Order.vue";
import OrderConfirm from "./OrderConfirm.vue";
import Delivery from "./Delivery.vue";
import DeliveryConfirm from "./DeliveryConfirm.vue";
import DeliveryEnd from "./DeliveryEnd.vue";
import DeliveryMail from "./DeliveryMail.vue";
import QA from "./QA.vue";
import ProductDetail from "./ProductDetail.vue";

export default {
  routes: [
    {
      path: "/shopping",
      component: Index,
    },
    {
      path: "/shopping/serial",
      component: SerialStart,
    },
    {
      path: "/shopping/serial/confirm",
      component: SerialConfirm,
    },
    {
      path: "/shopping/serial/end",
      component: SerialEnd,
    },
    {
      path: "/shopping/registration/:uux",
      component: RegistrationStart,
    },
    {
      path: "/shopping/registration",
      component: RegistrationStart,
    },
    {
      path: "/shopping/registration/confirm",
      component: RegistrationConfirm,
    },
    {
      path: "/shopping/order",
      component: Order,
    },
    {
      path: "/shopping/order/confirm",
      component: OrderConfirm,
    },
    {
      path: "/shopping/delivery",
      component: Delivery,
    },
    {
      path: "/shopping/delivery/confirm",
      component: DeliveryConfirm,
    },
    {
      path: "/shopping/delivery/end",
      component: DeliveryEnd,
    },
    {
      path: "/shopping/delivery/mail",
      component: DeliveryMail,
    },
    {
      path: "/shopping/qa",
      component: QA,
    },
    {
      path: "/shopping/products/:productNo",
      component: ProductDetail,
    },
  ],
};
